var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWorkspaceInstanceScroll = function SvgWorkspaceInstanceScroll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#707070",
    fill: "#FFF",
    fillRule: "nonzero",
    x: 2.5,
    y: 2.5,
    width: 15,
    height: 15,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA2FF0",
    d: "m5.385 10 7.384-4.615v9.23z"
  }))));
};

export default SvgWorkspaceInstanceScroll;